import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

export const DoohInventoryListStyled = styled.section`
  background: ${props => props.theme.uiColors.background01};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 20px;
  overflow: hidden;
  height: 100%;
  
  .screenInventoryList {
    overflow-y: auto;
    ${mixins.forceScrollbar as any}
  }
`;
